import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, FieldArray, reduxForm } from 'redux-form';
import React from 'react';
import { Col, FormGroup, Modal, Row } from 'react-bootstrap';
import { Checkbox } from '../../../../common/components/ReduxFormField';
import { Button } from '../../../../common/components';

const DocumentSelectField = ({ input }) => {
  const doc = input.value;
  return (
    <div>
      <Field
        label={doc.name}
        checkboxValue={doc.id}
        name={`${input.name}.selected`}
        component={Checkbox}
      />
    </div>
  );
};

const DocumentsArray = ({ fields }) => {
  // console.log(input);
  // const doc = input.value;
  return (
    <div>
      {fields.map((field) => (
        <Col sm={12} key={field}>
          <Field name={field} component={DocumentSelectField} />
        </Col>
      ))}
    </div>
  );
};
const DownloadDocumentsForm = ({
  onDownloadDocuments,
  handleSubmit,
  onCloseModal,
  resourceId,
  resourceType,
  submitting,
}) => {
  const handleDownload = (values) => {
    const selectedDocuments = values.selected_docs;
    const payload = {
      meta: {
        documents: selectedDocuments.reduce((carry, doc) => {
          if (!doc.selected) {
            return carry;
          }
          carry.push(doc.id);
          return carry;
        }, []),
      },
    };

    if (payload.meta.documents.count === 0) {
      return;
    }
    return Promise.resolve(onDownloadDocuments(payload, resourceId, resourceType)).then(
      () => {
        onCloseModal();
      },
    );
  };

  return (
    <form onSubmit={handleSubmit(handleDownload)}>
      <FormGroup>
        <Col xs={12}>
          <Row className="document-selection-list">
            <FieldArray name={'selected_docs'} component={DocumentsArray} />
          </Row>
        </Col>
      </FormGroup>

      <Modal.Footer>
        <Button type="submit" bsStyle="primary" isLoading={submitting} label="Download" />
      </Modal.Footer>
    </form>
  );
};

const FORM_NAME = 'DownloadDocumentsForm';

const getInitialValues = (documents) => (_state) => {
  const docs = Array.isArray(documents)
    ? documents.map((document) => ({
        selected: document?.id,
        name: document?.attributes?.name,
        id: document?.id,
      }))
    : [];

  return {
    selected_docs: docs,
  };
};

export default compose(
  connect(
    (state, ownProps) => ({
      initialValues: getInitialValues(ownProps.documents)(state),
    }),
    null,
  ),
  reduxForm({
    form: FORM_NAME,
  }),
)(DownloadDocumentsForm);
